<template>

	<v-content>
		<v-container fluid >

			<div class="TeklifOffersOffer" v-if="isLoading">
				<div class="text-xs-center pa-5">
					<v-progress-circular :size="50" color="indigo" indeterminate></v-progress-circular>
					<div class="caption mt-4">İşlem devam ediyor</div>
				</div>
			</div>

			<div class="TeklifOffersOffer" v-if="!isLoading">
				<div class="TeklifOffersOfferTitle">
					<span v-if="offer.id">Teklifi Düzenle</span>
					<span v-if="!offer.id">Yeni Teklif</span>
					<div class="TeklifOffersOfferActions">
						<v-btn  small outline color="#1ebea5" dark v-if="offer.id" @click="actShareOnWhatsapp()" >
							Whatsapp
						</v-btn>
						<v-btn small outline color="blue" dark v-if="offer.id" @click="actEmail()" :loading="isMailling">
							<v-icon left>email</v-icon> EMAİL
						</v-btn>
						<v-btn small outline color="red" dark v-if="offer.id" @click="actPdf()">
							<v-icon left>insert_drive_file</v-icon> PDF
						</v-btn>
						<v-menu offset-y content-class="dropdown-menu" transition="slide-y-transition" v-if="offer.id">
							<v-btn small outline slot="activator" color="teal">
								<v-icon left>print</v-icon>
								Yazdır
							</v-btn>
							<v-card>
								<v-list dense>
									<v-list-tile @click="actPrint(true)">
										<v-list-tile-title>Antetli Kağıt</v-list-tile-title>
									</v-list-tile>
									<v-list-tile @click="actPrint(false)">
										<v-list-tile-title>Düz Kağıt</v-list-tile-title>
									</v-list-tile>
								</v-list>
							</v-card>
						</v-menu>
						<v-menu offset-y content-class="dropdown-menu" transition="slide-y-transition">
							<v-btn small outline slot="activator" color="success">
								<v-icon left>save</v-icon>
								Kaydet
							</v-btn>
							<v-card>
								<v-list dense>
									<v-list-tile @click="saveOffer()">
										<v-list-tile-title>Üzerine Kaydet</v-list-tile-title>
									</v-list-tile>
									<v-list-tile @click="saveOfferAs()">
										<v-list-tile-title>Yeni Versiyon Olarak Kaydet</v-list-tile-title>
									</v-list-tile>
								</v-list>
							</v-card>
						</v-menu>
					</div>
				</div>
				<div class="TeklifOffersOfferBody">

					<v-container grid-list-md >
						<v-layout row wrap>  
							<v-flex xs12 sm4>
								<v-text-field outline label="Teklif Başlığı" v-model="offer.title" hide-details />
							</v-flex>
							<v-flex xs12 sm4>
								<v-select outline v-model="offer.customer_id" :items="customers" item-text="company" item-value="id" hide-details label="Müşteri Adı">

									<template slot="selection" slot-scope="data"> 
										<div class="tekifEditCustomerBox">
											<span class="tekifEditCustomerCompany">{{ data.item.company }}</span>
											<span class="tekifEditCustomerFullname">{{ data.item.fullname }}</span>
										</div> 
									</template>
									<template slot="item" slot-scope="data"> 
										<div class="tekifEditCustomerBox">
											<span class="tekifEditCustomerCompany">{{ data.item.company }}</span>
											<span class="tekifEditCustomerFullname">{{ data.item.fullname }}</span>
										</div> 
									</template>

								</v-select>
							</v-flex>
							<v-flex xs12 sm4>
								<v-text-field outline label="Müşteri EMail" :value="getCustomerEmail" hide-details readonly disabled/>
							</v-flex>


							<v-flex xs12 class="text-xs-center mt-3"> 
								<v-pagination v-model="offer.version_id" :length="offer.versions.length" prev-icon="chevron_left" next-icon="chevron_right"></v-pagination>
							</v-flex>
							<v-flex xs12 class="text-xs-center">
								<div>
									<span v-if="offer.versions[getVersionId].goruldu" class="green--text ">Görüldü</span> 
									<span v-if="!offer.versions[getVersionId].goruldu" class="grey--text ">Görülmedi</span>  
								</div> 
								<div>
									<span v-if="offer.versions[getVersionId].onaylandi" class="green--text "><b>ONAYLANDI</b></span> 
								</div> 
							</v-flex>

							<v-flex xs12 class="mt-3"> </v-flex>

							<v-flex xs12 sm4>
								<v-text-field outline label="Düzenleme Tarihi (dd.mm.yyyy)" v-model="offer.versions[getVersionId].date_edit" hide-details />
							</v-flex>
							<v-flex xs12 sm4>
								<v-text-field outline label="Geçerlilik Tarihi (dd.mm.yyyy)" v-model="offer.versions[getVersionId].date_end" hide-details />
							</v-flex>
							<v-flex xs12 sm4>
								<v-select outline :items="currencies" item-text="text" item-value="code" v-model="offer.versions[getVersionId].currency" hide-details label="Dövüz Kuru" />
							</v-flex>
							<v-flex xs12 class="mt-3"> </v-flex>
 
 
						</v-layout>
					</v-container>
 


					<div class="offerProducts">

						<table>
							<thead>
								<tr>
									<th style="min-width:180px">ÜRÜN ADI</th>
									<th style="min-width:90px" width="130px">MİKTAR</th>
									<th style="min-width:90px" width="100px">BR. FİYAT</th>
									<th style="min-width:90px" width="100px">İNDİRİM</th>
									<th style="min-width:90px" width="100px">VERGİ</th>
									<th style="min-width:90px" width="100px">TOPLAM</th> 
									<th width="10px"></th>
								</tr>
							</thead>
							<tbody v-if="renderComponent">
								<TeklifOffersOfferProductLine
									v-for="(productLine, productLineIndex) in offer.versions[getVersionId].products"
									:key="'productLine-'+getVersionId+'-'+productLineIndex" 
									v-model="offer.versions[getVersionId].products[productLineIndex]"
									:products="products" 
									:kdvs="kdvs" 
									v-on:remove="removeProductLine(productLineIndex)"
								/>
							</tbody>
						</table>
						<div class="text-xs-center">
							<v-btn round color="teal" dark @click="addProductLine()">Yeni Satır EKle</v-btn>
						</div>
					</div>

					<div class="offerTotals">
						<table>
							<tbody>
								<tr>
									<td>ARA TOPLAM</td>
									<td>
										<FloatSpan :value="offer.versions[getVersionId].ara_toplam" :append="getCurrencySymbol" formatMoney/>
									</td>
								</tr>
								<tr>
									<td>SATIR İNDİRİMİ</td>
									<td>
										<FloatSpan :value="offer.versions[getVersionId].satir_indirimi" :append="getCurrencySymbol" formatMoney/>
									</td>
								</tr>
								<tr>
									<td>GENEL İNDİRİM</td>
									<td>
										<FloatInputBox v-model="offer.versions[getVersionId].genel_indirim" />
									</td>
								</tr>
								<tr>
									<td>BÜRÜT TOPLAM</td>
									<td width="150px">
										<FloatSpan :value="offer.versions[getVersionId].burut_toplam" :append="getCurrencySymbol" formatMoney/>
									</td>
								</tr>
								<tr>
									<td>TOPLAM KDV</td>
									<td>
										<FloatSpan :value="offer.versions[getVersionId].toplam_kdv" :append="getCurrencySymbol" formatMoney/>
									</td>
								</tr>
								<tr>
									<td>GENEL TOPLAM</td>
									<td>
										<FloatSpan :value="offer.versions[getVersionId].genel_toplam" :append="getCurrencySymbol" formatMoney/> 
									</td>
								</tr>
							</tbody>
						</table>
					</div>




					<div class="offerTexts">
						<v-container grid-list-md >
							<v-layout row wrap>   
								<v-flex xs12>
									<label><b>Teklif Açıklaması</b></label>
									<ckeditor :editor="editor" v-model="offer.versions[getVersionId].text1" :config="editorConfig"></ckeditor>
								</v-flex>
								<v-flex xs12 class="mt-4">
									<label><b>Admin Notu</b></label>
									<ckeditor :editor="editor" v-model="offer.versions[getVersionId].text2" :config="editorConfig"></ckeditor>
								</v-flex>
								<!-- <v-flex xs12 class="mt-3"> </v-flex>
								
								<v-flex xs12 class="mt-4">
									<label><b>Teklif Şartları</b></label>
									<ckeditor :editor="editor" v-model="offer.versions[getVersionId].text2" :config="editorConfig"></ckeditor>
								</v-flex> -->
	
							</v-layout>
						</v-container>
					</div>




				</div>
			</div>

		</v-container>
	</v-content>


</template>


<script>
	import FloatSpan from "@/components/tools/FloatSpan.vue";
	import FloatInput from "@/components/tools/FloatInput.vue";
	import FloatInputBox from "@/components/tools/FloatInputBox.vue";
	import TeklifOffersOfferProductLine from "@/includes/Teklif/Offers/Offer/ProductLine.vue";
	import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
	export default {
		name: "TeklifOffersOffer",
		components: {
			FloatSpan,
			FloatInput,
			FloatInputBox,
			TeklifOffersOfferProductLine,
		},
		data() {
			return {
				renderComponent: true,
				isLoading: true,
				isMailling: false,
				categories: [],
				products: [],
				customers: [], 
				offer: {},
				
				currencies: [{
						code: "TRY",
						text: "Türk Lirası",
						symbol: "₺"
					},
					{
						code: "USD",
						text: "Ameriak Doları",
						symbol: "$"
					},
					{
						code: "EUR",
						text: "Euro",
						symbol: "€"
					},
				],
				kdvs : [
					{text : "0% KDV",value:0},
					{text : "8% KDV",value:8},
					{text : "18% KDV",value:18},
				],
				editor: ClassicEditor,
				editorConfig: {
					toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList'],
				}
			}
		},
		watch: { 
			"getAllLinesAndVersions": function () {
				this.calcTotals()
			}, 

		},
		mounted() {
			this.isLoading = true;
			this.loadOffer(); 

			this.loadCategories();
			this.loadProducts();
			this.loadCustomers();
		},
		methods: {
			forceRerender() { 
				this.renderComponent = false; 
				this.$nextTick(() => { 
					this.renderComponent = true;
				});
			},
			loadCategories() {
				this.$http.get(process.env.VUE_APP_API_URL + "/teklif/categories/", {
					params: {}
				}).then(response => {
					this.categories = response.body;
				})
			},
			loadProducts() {
				this.$http.get(process.env.VUE_APP_API_URL + "/teklif/products/", {
					params: {}
				}).then(response => {
					this.products = response.body;
				})
			},
			loadCustomers() {
				this.$http.get(process.env.VUE_APP_API_URL + "/teklif/customers/", {
					params: {}
				}).then(response => {
					this.customers = response.body;
				})
			}, 
			addProductLine() {
				this.offer.versions[this.getVersionId].products.push({
					product_name : "",
					adet : 1.0,
					fiyat : 0.0,
					ara_toplam : 0.0,
					indirim_miktari : 0.0,
					indirim_tipi : "TL",
					indirim_toplam : 0.0,
					burut_toplam : 0.0,
					kdv_orani : "18",
					kdv_miktari : 0.0,
					genel_toplam : 0.0, 
				});
			},
			removeProductLine(i){
				this.offer.versions[this.getVersionId].products.splice(i,1);
				this.forceRerender();
			},
			loadOffer() {
				this.isLoading = true;
				this.$http.get(process.env.VUE_APP_API_URL + "/teklif/offers/info", {
					params: {
						id: this.$route.query.id
					}
				}).then(response => {
					this.offer = response.body; 
					this.offer.customer_id = this.offer.customer_id.toString(); 
					setTimeout(() => {
						this.isLoading = false;
					}, 1)
				})
			},
			saveOffer() {
				this.isLoading = true;
				this.$http.post(process.env.VUE_APP_API_URL + "/teklif/offers/save", this.offer, {
					params: {}
				}).then(response => {  
					this.$router.push("/teklif/offers/offer/?id="+response.body.offer_id)
					this.loadOffer();
				})
			},
			saveOfferAs() {
				this.isLoading = true;
				this.$http.post(process.env.VUE_APP_API_URL + "/teklif/offers/save", this.offer, {
					params: {saveas : 1}
				}).then(response => { 
					this.$router.push("/teklif/offers/offer/?id="+response.body.offer_id)
					this.loadOffer();
				})
			},

			calcTotals() { 
				for(var v in this.offer.versions){
					var version = this.offer.versions[v]
					var ara_toplam = 0.0;
					var satir_indirimi = 0.0;
					var urunler_burut_toplam = 0.0; 
					for(var i in version.products){
						var product = version.products[i]
						ara_toplam += product.ara_toplam
						satir_indirimi += product.indirim_toplam 
						urunler_burut_toplam += product.burut_toplam 
					}
					version.ara_toplam = ara_toplam
					version.satir_indirimi = satir_indirimi  
					version.burut_toplam = urunler_burut_toplam - version.genel_indirim

					var toplam_kdv = 0.0;
					for(var i in version.products){
						var product = version.products[i]
						var urun_burut_oran = product.burut_toplam * 100 / urunler_burut_toplam
						var indirim_for_urun = version.genel_indirim / 100 * urun_burut_oran 
						toplam_kdv += parseFloat( (product.burut_toplam - indirim_for_urun) / 100 * parseInt(product.kdv_orani) )
					}
					version.toplam_kdv = toplam_kdv  
					version.genel_toplam = toplam_kdv  + version.burut_toplam

				} 
			}, 

			actEmail(){
				this.isMailling = true;
				this.$http.get(process.env.VUE_APP_API_URL + "/teklif/offers/sendmail", {
					params: {
						id: this.offer.id
					}
				}).then(response => { 
					this.isMailling = false;
				})
			},
			actPdf(){
				window.open("http://crm.ajans360.com/?pdf=1&offer_token="+this.offer.offer_token,'_blank');
			},
			actPrint(){
				window.open("http://crm.ajans360.com/?offer_token="+this.offer.offer_token,'_blank');
			},
			actShareOnWhatsapp(){
				var whatsapplink = "whatsapp://send?";
				if(this.getCustomerWhatsapp){
					whatsapplink += "phone=" + this.getCustomerWhatsapp + "&";
				}
				whatsapplink += "text=" + encodeURIComponent("http://crm.ajans360.com/?offer_token="+this.offer.offer_token);
				window.open(whatsapplink,'_blank');
			},


		},
		computed: {
			getCustomerEmail(){
				if(this.offer.customer_id){
					for(var i in this.customers){
						if(parseInt(this.customers[i].id) == parseInt(this.offer.customer_id)){
							return this.customers[i].email || ""
						}
					}
				}
				return '';
			},
			getCustomerWhatsapp(){
				if(this.offer.customer_id){
					for(var i in this.customers){
						if(parseInt(this.customers[i].id) == parseInt(this.offer.customer_id)){
							if(this.customers[i].whatsapp){
								return this.customers[i].whatsapp.replace("+").replace(" ")
							}
						}
					}
				}
				return '';
			},
			getVersionId(){
				return this.offer.version_id -1
			},
			getCurrencySymbol() {
				for (var i in this.currencies) {
					if (this.offer.currency == this.currencies[i].code) {
						return this.currencies[i].symbol
					}
				}
				return "₺"
			},
			getAllLinesAndVersions(){
				// var products = [];
				// for(var v in this.offer.versions){  
				// 	for(var i in this.offer.versions[v].products[i]){
				// 		this.push(products)
				// 	} 
				// }
				return JSON.stringify(this.offer)
			}
		}
	}
</script>

<style lang="less">
	.tekifEditCustomerBox{
		.tekifEditCustomerCompany{ 
		}
		.tekifEditCustomerFullname{
			font-size: 12px;
			margin-left:10px;
			color:#aaa;
			line-height: 24px; 
		}
	}
	.TeklifOffersOffer {
		width: 100%;
		background-color: #fff;
		box-shadow: 0 0 3px rgb(107, 107, 107);
		
		.TeklifOffersOfferTitle {
			border-bottom: 2px solid #ccc;
			font-weight: 700;
			padding: 20px;
			position: relative;

			.TeklifOffersOfferActions {
				position: absolute;
				right: 2px;
				top: 10px;
				@media(max-width:768px){
					position: relative;
					text-align: center;
					width:100%;
					.v-btn {
						margin:3px;
						.v-icon {
							font-size:13px;
						}
					}
				}
				.v-btn {
					padding: 0 10px;

					.v-icon {
						margin-right: 3px;
					}
				}

				.listitem {
					&:hover {
						color: #ccc;
						cursor: pointer;
					}
				}
			}
		}

		.TeklifOffersOfferBody {
			padding: 20px;
			
			.offerContent {
				width: 600px;
				max-width: calc(~"100% - 30px");
				margin: 0px auto;

				.contentLine {
					margin-bottom: 20px;

					&>label {
						font-size: 12px;
						font-weight: 700;
					}
				}

			}

			.isNewCustomer {
				font-weight: 700;
				color: rgb(0, 57, 212);

				.v-input {
					margin-top: 2px;

					label {
						font-size: 13px;
					}
				}
			}

			.offerProducts {
				margin: 20px 0px;
				overflow-x: auto;
				table {
					width: 100%;
					border-collapse: collapse;
					border-spacing: 0;

					thead {
						tr {
							th {
								border-bottom: 2px solid #ccc;
								text-align: left;
								padding: 12px 10px;
								font-family: "Roboto Condensed", "Helvetica Neue", Helvetica, Arial, sans-serif;
								font-weight: 700;
							}
						}
					}

					tbody {
						tr {
							td {
								padding: 10px;
							}
						}
					}
				}

				.TeklifOffersOfferProductLine {
					.FloatInputBox {
						height: 30px;
						font-size: 12px;
						padding: 6px 9px;
					}

					input,
					select {
						font-family: "Roboto Condensed", "Helvetica Neue", Helvetica, Arial, sans-serif;
					}
				}
			}

			.offerTotals {
				&::after{
					content: '';
					display: table;
					clear: both;
				}
				table {
					width: 300px;
					border-collapse: collapse;
					border-spacing: 0;
					float: right;
					margin-bottom: 50px;
					@media(max-width:600px){
						width:100%;
					}

					&::after {
						content: '';
						display: table;
						position: relative;
						clear: both;
					}

					tbody {
						tr {
							td {
								border-bottom: 2px solid #ccc;
								padding: 12px 10px;
								font-family: "Roboto Condensed", "Helvetica Neue", Helvetica, Arial, sans-serif;
								font-weight: 700;

								&:first-child {
									text-align: left;
								}

								&:last-child {
									padding: 0px 10px;
									text-align: right;

									input {
										text-align: right;
										float: right;
										height: 30px;
										font-size: 12px;
										padding: 6px 9px;
									}
								}
							}
						}
					}
				}
			}


			.offerTexts{
				margin-bottom:200px;
				@media(max-width:600px){
					.container{
						padding: 0px;
					}
				}
			}

		}
	}
</style>